<template>
  <div class="growthFileReport">
    <div v-if="version == 1">
      <div class="pageInnerBox" style="width: 900px">
        <div class="page pageCover">
          <div class="titleBox">
            <h5>成长档案</h5>
            <p class="line"></p>
            <p>Growth Profile</p>
          </div>
          <div class="nameBox">
            <p class="name">
              {{
                baseInfoStudentCensus.student &&
                baseInfoStudentCensus.student.name
              }}
            </p>
            <p class="time">报告编号：{{ reportNum }}</p>
            <p class="time">报告时间：{{ createdAt }}</p>
          </div>
        </div>
        <div class="pageInner"></div>
        <div class="page pageBackCover">
          <div class="titleBox">
            <h5>成长档案</h5>
            <p>Growth Profile</p>
          </div>
        </div>
      </div>
      <div class="pageDownlond" style="width: 900px; margin: 0 auto">
        <PageList></PageList>
        <!--part1基本信息-->
        <PageStudentMessage
          :baseInfoStudentCensus="baseInfoStudentCensus"
        ></PageStudentMessage>
        <!--成绩记录-->
        <PageGradeList
          :baseInfoScoreRecord="baseInfoScoreRecord"
        ></PageGradeList>
        <!--竞赛信息，综合素质-->
        <PageCompetiton
          :baseInfoCompetition="baseInfoCompetition"
          :baseInfoComplexQuality="baseInfoComplexQuality"
        ></PageCompetiton>
        <!--        &lt;!&ndash;part2个人特质&ndash;&gt;-->
        <!-- <div class="content" style="height: 1116px">
          <BigTitle title="part.2 个人特质"></BigTitle>
          <MiddleTitle title="人格特性"></MiddleTitle>
          <Rgtx :reportId="reportId" :personality="personality"></Rgtx>
          <div style="margin-bottom: 30px"></div>

          <MiddleTitle title="智能水平"></MiddleTitle>
          <div style="margin-top: 30px">
            <Rzqn :reportId="reportId" :norm="norm"></Rzqn>
          </div>
        </div> -->
        <!-- <div class="content" style="height: 1116px">
          <MiddleTitle title="兴趣倾向"></MiddleTitle>
          <Xqqx :reportId="reportId" :idx="idx" :norm="normXqqx"></Xqqx>
        </div>
        <div class="content" style="height: 1116px">
          <MiddleTitle title="心理适应性"></MiddleTitle>
          <Xljk :reportId="reportId" :norm="normXLJK"></Xljk>
        </div> -->
        <!-- &lt;!&ndash;part3我的目标&ndash;&gt;-->
        <PageMyGoal
          :myGoalPlan="myGoalPlan"
          :version="version"
          :professional='professional'
          :myGoalPlanAdjust="myGoalPlanAdjust"
        ></PageMyGoal>
        <PageTargetSplit
          :myGoalDisassemble="myGoalDisassemble"
        ></PageTargetSplit>
        <!--        &lt;!&ndash;part4行动计划&ndash;&gt;-->
        <PagePlanStatistics
          :actionPlanStatistics="actionPlanStatistics"
        ></PagePlanStatistics>
        <PagePlanStudyDevelop
          :actionPlanLearnHabit="actionPlanLearnHabit"
        ></PagePlanStudyDevelop>
        <!--&lt;!&ndash;part5咨询记录&ndash;&gt;-->
        <PageRecord :consultativeRecord="consultativeRecord"></PageRecord>
      </div>
    </div>
    <div v-if="version == 2">
      <div class="pageInnerBox" style="width: 900px">
        <div class="page pageCover">
          <div class="titleBox">
            <h5>成长档案</h5>
            <p class="line"></p>
            <p>Growth Profile</p>
          </div>
          <div class="nameBox">
            <p class="name">
              {{
                baseInfoStudentCensus.student &&
                baseInfoStudentCensus.student.name
              }}
            </p>
            <p class="time">报告编号：{{ reportNum }}</p>
            <p class="time">报告时间：{{ createdAt }}</p>
          </div>
        </div>
        <div class="pageInner"></div>
        <div class="page pageBackCover">
          <div class="titleBox">
            <h5>成长档案</h5>
            <p>Growth Profile</p>
          </div>
        </div>
      </div>
      <div class="pageDownlond" style="width: 900px; margin: 0 auto">
        <PageList2></PageList2>
        <!--part1基本信息-->
        <PageStudentMessage2
          :baseInfoStudentCensus="baseInfoStudentCensus"
        ></PageStudentMessage2>
        <!--成绩记录-->
        <PageGradeList2
          :baseInfoScoreRecord="baseInfoScoreRecord"
        ></PageGradeList2>
        <!--竞赛信息，综合素质-->
        <PageCompetiton2
          :baseInfoCompetition="baseInfoCompetition"
          :baseInfoComplexQuality="baseInfoComplexQuality"
        ></PageCompetiton2>
        <!--        &lt;!&ndash;part2个人特质&ndash;&gt;-->
        <!-- <div class="content" style="height: 1116px">
          <BigTitle2 title="part.2 个人特质"></BigTitle2>
          <MiddleTitle2 title="人格特性"></MiddleTitle2>
          <Rgtx2 :mbti="mbti"></Rgtx2>
          

          <MiddleTitle2 title="智能水平"></MiddleTitle2>
          <div style="margin-top: 20px">
            <Znsp2 :intelligent="intelligent"></Znsp2>
          </div>
        </div>
        <div class="content" style="height: 1116px">
          <MiddleTitle2 title="兴趣倾向"></MiddleTitle2>
          <Xqqx2 :hobby="hobby" :radarChart="radarChart"></Xqqx2>
        </div>
        <div class="content" style="height: 1116px">
          <MiddleTitle2 title="职业价值观"></MiddleTitle2>
          <Zyjzg2 :profession="profession"></Zyjzg2>

          <MiddleTitle2
              title="心理适应性"
            ></MiddleTitle2>
            <Xlsyx2 :mind="mind" :result="result"></Xlsyx2>
          
        </div> -->

        <!-- &lt;!&ndash;part3我的目标&ndash;&gt;-->
        <PageMyGoal2
          :myGoalPlan="myGoalPlan"
          :version="version"
          :myGoalPlanAdjust="myGoalPlanAdjust"
        ></PageMyGoal2>
        <PageTargetSplit2
          :myGoalDisassemble="myGoalDisassemble"
        ></PageTargetSplit2>
        <!--        &lt;!&ndash;part4行动计划&ndash;&gt;-->
        <PagePlanStatistics2
          :actionPlanStatistics="actionPlanStatistics"
        ></PagePlanStatistics2>
        <PagePlanStudyDevelop2
          :actionPlanLearnHabit="actionPlanLearnHabit"
        ></PagePlanStudyDevelop2>
        <!--&lt;!&ndash;part5咨询记录&ndash;&gt;-->
        <PageRecord2 :consultativeRecord="consultativeRecord"></PageRecord2>
      </div>
    </div>
    <div v-if="version == 0">
      <div class="pageInnerBox" style="width: 900px">
        <div class="page pageCover">
          <div class="titleBox">
            <h5>成长档案</h5>
            <p class="line"></p>
            <p>Growth Profile</p>
          </div>
          <div class="nameBox">
            <p class="name">
              {{
                baseInfoStudentCensus.student &&
                baseInfoStudentCensus.student.name
              }}
            </p>
            <p class="time">报告编号：{{ reportNum }}</p>
            <p class="time">报告时间：{{ createdAt }}</p>
          </div>
        </div>
        <div class="pageInner"></div>
        <div class="page pageBackCover">
          <div class="titleBox">
            <h5>成长档案</h5>
            <p>Growth Profile</p>
          </div>
        </div>
      </div>
      <div class="pageDownlond" style="width: 900px; margin: 0 auto">
        <PageList2></PageList2>
        <!--part1基本信息-->
        <PageStudentMessage2
          :baseInfoStudentCensus="baseInfoStudentCensus"
        ></PageStudentMessage2>
        <!--成绩记录-->
        <PageGradeList2
          :baseInfoScoreRecord="baseInfoScoreRecord"
        ></PageGradeList2>
        <!--竞赛信息，综合素质-->
        <PageCompetiton2
          :baseInfoCompetition="baseInfoCompetition"
          :baseInfoComplexQuality="baseInfoComplexQuality"
        ></PageCompetiton2>
        <!--        &lt;!&ndash;part2个人特质&ndash;&gt;-->
        <!-- <div class="content" style="height: 1116px">
          <BigTitle2 title="part.2 个人特质"></BigTitle2>
          <MiddleTitle2 title="人格特性"></MiddleTitle2>
          <Rgtx2 :mbti="mbti"></Rgtx2>
          

          <MiddleTitle2 title="智能水平"></MiddleTitle2>
          <div style="margin-top: 20px">
            <Znsp2 :intelligent="intelligent"></Znsp2>
          </div>
        </div>
        <div class="content" style="height: 1116px">
          <MiddleTitle2 title="兴趣倾向"></MiddleTitle2>
          <Xqqx2 :hobby="hobby" :radarChart="radarChart"></Xqqx2>
        </div>
        <div class="content" style="height: 1116px">
          <MiddleTitle2 title="职业价值观"></MiddleTitle2>
          <Zyjzg2 :profession="profession"></Zyjzg2>

          <MiddleTitle2
              title="心理适应性"
            ></MiddleTitle2>
            <Xlsyx2 :mind="mind" :result="result"></Xlsyx2>
          
        </div> -->

        <!-- &lt;!&ndash;part3我的目标&ndash;&gt;-->
        <PageMyGoal2
          :myGoalPlan="myGoalPlan"
          :version="version"
          :myGoalPlanAdjust="myGoalPlanAdjust"
        ></PageMyGoal2>
        <PageTargetSplit2
          :myGoalDisassemble="myGoalDisassemble"
        ></PageTargetSplit2>
        <!--        &lt;!&ndash;part4行动计划&ndash;&gt;-->
        <PagePlanStatistics2
          :actionPlanStatistics="actionPlanStatistics"
        ></PagePlanStatistics2>
        <PagePlanStudyDevelop2
          :actionPlanLearnHabit="actionPlanLearnHabit"
        ></PagePlanStudyDevelop2>
        <!--&lt;!&ndash;part5咨询记录&ndash;&gt;-->
        <PageRecord2 :consultativeRecord="consultativeRecord"></PageRecord2>
      </div>
    </div>
  </div>
</template>
<script>
// import Add from '@/components/consultant/Add.vue'

import Rgtx from "./components/evalutionReport/rgtx";
import Rzqn from "./components/evalutionReport/rzqn";
import Xqqx from "./components/evalutionReport/xqqx";
import Xljk from "./components/evalutionReport/xljk";

import PageList from "./components/pageList.vue";
import PageStudentMessage from "./components/pageStudentMessage.vue";
import PageGradeList from "./components/pageGradeList.vue";
import PageCompetiton from "./components/pageCompetiton.vue";
import PageMyGoal from "./components/pageMyGoal.vue";
import PageRecord from "./components/pageRecord.vue";
import PageTargetSplit from "./components/pageTargetSplit.vue";

import PagePlanStudyDevelop from "./components/pagePlanStudyDevelop.vue";
import PagePlanStatistics from "./components/pagePlanStatistics.vue";

import BigTitle from "./components2/bigTitle";
import MiddleTitle from "./components2/middleTitle";
import SmallTitle from "./components2/smallTitle";

// import Add2 from '@/components2/consultant/Add.vue'

import Rgtx2 from "./components2/evalutionReport/rgtx";
import Znsp2 from "./components2/evalutionReport/znsp";
import Xqqx2 from "./components2/evalutionReport/xqqx";
import Xljk2 from "./components2/evalutionReport/xljk";
import Zyjzg2 from "./components2/evalutionReport/zyjzg";
import Xlsyx2 from "./components2/evalutionReport/xlsyx";

import PageList2 from "./components2/pageList.vue";
import PageStudentMessage2 from "./components2/pageStudentMessage.vue";
import PageGradeList2 from "./components2/pageGradeList.vue";
import PageCompetiton2 from "./components2/pageCompetiton.vue";
import PageMyGoal2 from "./components2/pageMyGoal.vue";
import PageRecord2 from "./components2/pageRecord.vue";
import PageTargetSplit2 from "./components2/pageTargetSplit.vue";

import PagePlanStudyDevelop2 from "./components2/pagePlanStudyDevelop.vue";
import PagePlanStatistics2 from "./components2/pagePlanStatistics.vue";

import BigTitle2 from "./components2/bigTitle";
import MiddleTitle2 from "./components2/middleTitle";
import SmallTitle2 from "./components2/smallTitle";
export default {
  name: "growthFileReport",
  props:['componentId'],
  components: {
    Rgtx,
    Rzqn,
    Xqqx,
    Xljk,
    PageList,
    PageStudentMessage,
    PageGradeList,
    PageCompetiton,
    PageMyGoal,
    PageRecord,
    PageTargetSplit,
    PagePlanStudyDevelop,
    PagePlanStatistics,
    BigTitle,
    MiddleTitle,
    SmallTitle,
    Rgtx2,
    Znsp2,
    Xqqx2,
    Xljk2,
    PageList2,
    PageStudentMessage2,
    PageGradeList2,
    PageCompetiton2,
    PageMyGoal2,
    PageRecord2,
    PageTargetSplit2,
    PagePlanStudyDevelop2,
    PagePlanStatistics2,
    BigTitle2,
    MiddleTitle2,
    SmallTitle2,
    Zyjzg2,
    Xlsyx2,
    
  },
  data() {
    return {
      // studentId: sessionStorage.getItem('myStudentStudentId'),
      parentId:'',
      studentId: sessionStorage.getItem('myStudentStudentId'),
      id: this.$route.query.id,
      userType: this.$route.query.userType,
      name: "",
      school: "",
      sexName: "",
      actionPlanLearnHabit: [],
      actionPlanStatistics: [],
      baseInfoCompetition: [],
      baseInfoComplexQuality: [],
      baseInfoScoreRecord: [],
      baseInfoStudentCensus: {},
      consultativeRecord: [],
      myGoalDisassemble: [], //目标拆解
      myGoalPlan: {},
      myGoalPlanAdjust: [],
      reportId: "",
      reportNum: "",
      createdAt: "",

      personality: {},
      norm: [],
      normXqqx: {},
      normXLJK: {},

      options: {},
      options2: {},
      options3: {},
      scores: [],
      tagNames: {},
      idx: 0,

      reportId: "",
      version: "",
      mbti: {},
      intelligent: [],
      hobby: {},
      radarChart: [],
      radarValue: [],
      radarZhuData: [],
      radarZhuVal: [],
      Data: [],
      profession: {}, //职业倾向
      mind: {},
      result: [],
      bgArr: [], //八卦
      bgNewArr: [
        "R-实际型",
        "C-传统型",
        "E-企业型",
        "S-社会型",
        "A-艺术型",
        "I-研究型",
      ],
      bgNewArr2: [],
      threeYard: "",
      professional:'',
    };
  },
  computed: {
    api() {
      let userType = this.userType;
      // 1学生2家长3咨询师
      if (userType == 1) {
        return this.ports.student.student.growth.getGrowthFileDetailByStudent;
      } else if (userType == 2) {
        return this.ports.parent.student.growth.getGrowthFileDetailByParent;
      } else {
        return this.ports.consultant.student.mine.growthFile
          .getGrowthFileDetail;
      }
    },
  },
  created() {},
  mounted() {
   // this.reportId='02b4998babda49d58a0a7bb7c3c6211a';
   this.getGrowthFileDetail();
   //this.judgeNewOld()
   
    
    // this.getReportData(this.reportId);
    // this.getStudentDetail();
  // this.getParentId()
  
  },
  methods: {
     getParentId(){
      this.$ajax.post(this.G_acapi+this.ports.parent.student.growth.getLastGrowthFileIdByParent,{},{
        headers: {
              token: window.sessionStorage.getItem("ymtxToken"),
            },
      }).then((res) => {
        
        this.parentId = res.data.data.id
       
         this.getGrowthFileDetail(this.parentId)
      })
    },
    judgeNewOld() {
      let id = this.$route.query.id;
      this.$ajax
        .post(
          this.G_acapi + this.api,
          {
            id: id,
          },
          {
            headers: {
              token: window.sessionStorage.getItem("ymtxToken"),
            },
          }
        )
        .then((res) => {          
          if (res.data.code == 2000) {
            this.version = res.data.data.version;
            this.reportId = res.data.data.reportId;           
            if (this.version == 2) {
              this.getReportData(this.reportId);             
            }
          } else {
          }
        });
    },
    getGrowthFileDetail() {
      let id = this.$route.query.id;
      let api = this.api;
      this.$ajax
        .post(
          this.G_acapi + api,
          {
            id: id,
          },
          {
            headers: {
              token: window.sessionStorage.getItem("ymtxToken"),
            },
          }
        )
        .then((res) => {
          if (res.data.code === 2000) {
            let data = res.data.data;
           
            let id = data.reportId
            this.actionPlanLearnHabit = data.actionPlanLearnHabit;
            this.actionPlanStatistics = data.actionPlanStatistics;
            this.baseInfoCompetition = data.baseInfoCompetition;
            this.baseInfoComplexQuality = data.baseInfoComplexQuality;
            this.baseInfoScoreRecord = data.baseInfoScoreRecord;
            this.baseInfoStudentCensus = data.baseInfoStudentCensus;
            this.consultativeRecord = data.consultativeRecord;
            this.myGoalDisassemble = data.myGoalDisassemble; //目标拆解
            this.myGoalPlan = data.myGoalPlan;
            // this.professional = data.professional
            // console.log(this.professional)
            this.myGoalPlanAdjust = data.myGoalPlanAdjust;
            this.reportId = data.reportId;
            this.reportNum = data.reportNum;
            this.createdAt = data.createdAt;

            this.version = res.data.data.version;
            this.reportId = res.data.data.reportId;
            //  this.version=2;
            //  this.reportId='02b4998babda49d58a0a7bb7c3c6211a';
            if (this.version == 1) {               
                Promise.all([
                // this.getRgtx(id),
                // this.getRzqn(id),
                // this.getXljk(id),
                // this.getXqqx(id),
              ]).then((values) => {
                this.$nextTick(() => {
                  this.countPage();
                });
              });             
            }else if(this.version == 2){
              this.getReportData(this.reportId);
               
            } else if(this.version == 0){
              this.$nextTick(() => {
                 this.countPage();             
              });
              
            }
            // Promise.all([
            //   this.getRgtx(id),
            //   this.getRzqn(id),
            //   this.getXljk(id),
            //   this.getXqqx(id),
            // ]).then((values) => {
            //   this.$nextTick(() => {
            //     this.countPage();
            //   });
            // });
            
          }
        });
    },
    getStudentDetail() {
      let studentId = this.studentId;
      this.$ajax
        .post(
          this.G_acapi + this.ports.consultant.student.new.getReportId,
          {
            studentId: studentId,
          },
          {
            headers: {
              token: window.sessionStorage.getItem("ymtxToken"),
            },
          }
        )
        .then((res) => {
          let data = res.data;
          if (data.code === 2000) {
            let { name, sexName, school } = res.data.data;
            this.name = name;
            this.school = school;
            this.sexName = sexName;
          }
        });
    },

    getRgtx(id) {
      return new Promise((resolve, reject) => {
        this.$ajax
          .post(
            this.G_report + this.ports.consultant.student.report.rgtx,
            {
              report_id: id,
            },
            {
              headers: {
                token: window.sessionStorage.getItem("ymtxToken"),
              },
            }
          )
          .then((res) => {
            let data = res.data;
            if (data.code == 0) {
              const { personality } = data.result;
              this.personality = personality;
              this.idx = 1;
              resolve("rgtx");
            }
          });
      });
    },
    getRzqn(id) {
      return new Promise((resolve, reject) => {
        this.$ajax
          .post(
            this.G_report + this.ports.consultant.student.report.rzqn,
            {
              report_id: id,
            },
            {
              headers: {
                token: window.sessionStorage.getItem("ymtxToken"),
              },
            }
          )
          .then((res) => {
            let data = res.data;
            if (data.code == 0) {
              const { norm } = res.data.result;
              this.norm = norm;

              resolve("rzqn");
            }
          });
      });
    },
    getXljk(id) {
      return new Promise((resolve, reject) => {
        this.$ajax
          .post(
            this.G_report + this.ports.consultant.student.report.xljk,
            {
              report_id: id,
            },
            {
              headers: {
                token: window.sessionStorage.getItem("ymtxToken"),
              },
            }
          )
          .then((res) => {
            let data = res.data;
            if (data.code == 0) {
              const { norm } = res.data.result;
              this.normXLJK = norm;
              resolve("Xljk");
            }
          });
      });
    },
    getXqqx(id) {
      return new Promise((resolve, reject) => {
        this.$ajax
          .post(
            this.G_report + this.ports.consultant.student.report.xqqx,
            {
              report_id: id,
            },
            {
              headers: {
                token: window.sessionStorage.getItem("ymtxToken"),
              },
            }
          )
          .then((res) => {
            let data = res.data;
            if (data.code == 0) {
              const { norm, data } = res.data.result;
              this.normXqqx = norm;
              let scores = [];
              scores.push(data.shehui);
              scores.push(data.qiye);
              scores.push(data.changgui);
              scores.push(data.shiji);
              scores.push(data.diaoyan);
              scores.push(data.yishu);
              let tagNames = [
                {
                  name: "S社会",
                  max: 100,
                },
                {
                  name: "E企业",
                  max: 100,
                },
                {
                  name: "C常规",
                  max: 100,
                },
                {
                  name: "R实际",
                  max: 100,
                },
                {
                  name: "I调研",
                  max: 100,
                },
                {
                  name: "A艺术",
                  max: 100,
                },
              ];

              this.draw(scores, tagNames);
              resolve("Xqqx");
            }
          });
      });
    },

    draw(scores, tagNames) {
      // 基于准备好的dom，初始化echarts实例
      this.options = {
        tooltip: {},
        legend: {
          data: ["兴趣倾向评估"],
        },
        radar: {
          name: {
            color: "#000",
            fontSize: 14,
            textStyle: {
              color: "#FFFFFF",
              backgroundColor: "#29AAF4",
              borderRadius: 3,
              padding: [5, 10],
              lineHeight: 16,
            },
          },
          indicator: tagNames,
          splitArea: {
            show: true,
            areaStyle: {
              color: ["#F6FCFC", "#E5F2F9", "#F6FCFC", "#E5F2F9", "#F6FCFC"],
              // 图表背景网格的颜色
            },
          },
        },

        calculable: true,
        series: [
          {
            type: "radar",
            symbol: "circle",
            data: [
              {
                value: scores,
                name: "兴趣倾向评估结果",
              },
            ],
            lineStyle: {
              color: "#29AAF4",
            },
            symbolSize: 8,
            color: "#29AAF4",
          },
        ],
      };
    },

    countPage() {
      let html1 = '<div class="page pdf-page">';
      let html2 = "</div></div>";
      let allHtml =
        '<div class="page pdf-page"><p class="big_page_number">1</p>';
      // let allHtml = '<div class="page_shadow"><div class="page pdf-page">';
      let pageNumber = 1;
      let height = 1120;
      let page_content_height = 0;
      $(".content").each(function () {
        // let nowHtml = $(this).outerHTML();
        let nowHtml = $(this).prop("outerHTML");
        let nowHeight = $(this).innerHeight();
        page_content_height += nowHeight;
        // console.log(nowHeight)
        if (page_content_height <= height) {
          allHtml = allHtml + nowHtml;
        } else {
          pageNumber++;
          let elPageNumber =
            '<p class="big_page_number">' + pageNumber + "</p>";
          page_content_height = nowHeight;
          allHtml = allHtml + html2 + html1 + nowHtml + elPageNumber;
        }
      });
      allHtml = allHtml + html2;
      $(".pageInner").append(allHtml);
      $(".pageDownlond").css("display", "none");
      this.countListPage();
      this.$nextTick(() => {
        //let options = this.options;
        // let myChart = this.$echarts.init(document.getElementById('radarChartContainer'));
        // // 使用刚指定的配置项和数据显示图表。
        // myChart.setOption(options);
        
        if(this.version == 1){
          var echarts = require("echarts");
          var myChart = echarts.init(document.getElementById("radarChartContainer"));
          myChart.setOption(this.options)
        }else{
          var echarts2 = require("echarts");
        var myChart2 = echarts2.init(document.getElementById("Gossip"));
        myChart2.setOption(this.options2);
        var echarts3 = require("echarts");
        var myChart3 = echarts3.init(document.getElementById("lineTu"));
        myChart3.setOption(this.options3);
        }
        
        
      });
    },
    countListPage() {
      $(".middleTitle").each(function (idx) {
       
        let number = $(this).parent().parent().find(".big_page_number").text();
        $(".small_title_box").eq(idx).find(".page_number").html(number);
      });
    },
    drawBagua(value) {

      var iarr = [];
      this.options2 = {
        tooltip: {
          trigger: "item",
        },
        radar: {
          // shape: 'circle',
          name: {
            formatter: function (val) {
             
              let values = false;
              for (let i = 0; i < value.length; i++) {
                if (value[i].name == val && value[i].color) {
                  values = true;
                  break;
                }
              }
              if (values) {
                return "{a|" + val + "}";
              } else {
                return "{b|" + val + "}";
              }
            },

            rich: {
              a: {
                color: "#1CA4B6",
                fontSize: 18,
              },
              b: {
                color: "#2F2F2F",
                fontSize: 14,
              },
            },
            textStyle: {
              color: "#4D4D4D",
              fontSize: 14,
              fontWeight: "bold",
              padding: [3, 5],
            },
          },

          axisLine: {
            //指向外圈文本的分隔线样式
            lineStyle: {
              type: "dashed",
            },
          },
          splitArea: {
            show: true,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
            },
          },
          radius: "70%",
          center: ["50%", "50%"],
          // indicator: this.bgArr,
          indicator: value,
        },
        series: [
          {
            name: "测评结果",
            type: "radar",
            // areaStyle: {normal: {}},
            data: [
              {
                value: this.radarValue,
                name: "测评结果",
                label: {
                  show: true,
                  formatter: function (params) {
                    iarr.push(params);
                    // if (params.value <= 10) {
                    //   return "{a|" + params.value + "}";
                    // } else {
                    //   return "{b|" + params.value + "}";
                    // }
                    for (var i = 0; i < value.length; i++) {
                      if (
                        value[i].value == params.value &&
                        value[iarr.length - 1].color
                      ) {
                        return "{b|" + params.value + "}";
                      }
                    }
                  },
                  rich: {
                    a: {
                      color: "#2F2F2F",
                      fontSize: 14,
                    },
                    b: {
                      color: "#1CA4B6",
                      fontSize: 18,
                    },
                  },
                },
              },
            ],
            areaStyle: {
              color: "rgba(184,232,255,0.8)",
            },
            lineStyle: {
              color: "#1CA4B6",
              width: 2,
            },
            label: {
              show: true,
              position: "top",
              fontSize: 14,
              color: "#2F2F2F",

              // fontWeight:'bold'
            },
            symbol: "circle",
            symbolSize: 4,
            showAllSymbol: false,

            itemStyle: {
              color: "white",
              borderColor: "#1CA4B6",
              borderWidth: 2,
            },
          },
        ],
      };
    },
    drawZhu(value) {
      

      var bkData = [100, 100, 100, 100, 100, 100, 100, 100];
      this.options3 = {
        backgroundColor: "",
        color: ["#3398DB"],
        tooltip: {
          show: false,
          trigger: "axis",
          axisPointer: {
            type: "line",
            lineStyle: {
              opacity: 0,
            },
          },
          backgroundColor: "rgb(7,55,133)",
          borderColor: "#0daee9",
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "5%",
          right: "5%",
          bottom: "5%",
          top: "10%",
          height: "85%",
          containLabel: true,
          z: 22,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: true, // 坐标轴两边留白
            gridIndex: 0,
            data: this.radarZhuData,
            axisLabel: {
              textStyle: {
                fontSize: 12,
              },
            },
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,.8)",
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            min: 0,
            max: 30,
            minInterval: 5,
            interval: 5,
            name: "分值",
            type: "value",
            nameTextStyle: {
              color: "rgb(170,170,170)",
            },
            gridIndex: 0,
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "rgba(224, 222, 222, 1)",
              },
            },
            axisLabel: {
              color: "rgba(0,0,0,.8)",
              fontSize: 12,
              formatter: "{value}",
            },
            splitLine: {
              lineStyle: {
                color: "rgba(224, 222, 222, 1)",
              },
            },
          },
          {
            type: "value",
            show: false,
            gridIndex: 0,
            // min: min,
            // max: 6,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#95a2aa",
              fontSize: 14,
              formatter: "{value}",
            },
            splitLine: {
              lineStyle: {
                color: "rgba(255,255,255,.1)",
              },
            },
          },
        ],
        series: [
          {
            // name: "高发事件统计",
            type: "bar",
            barWidth: "30%",
            xAxisIndex: 0,
            yAxisIndex: 0,
            itemStyle: {
              // normal: {
              //   color: function (params) {
              //     return colors[params.dataIndex];
              //   },
              // },
              color: function (params) {
                function f(a, b) {
                  return -(a - b);
                }
                value.sort(f);

                if (value[0] == params.value) {
                  return "#FEAE3B";
                } else if (value[1] == params.value) {
                  return "#1CA4B6";
                } else if (value[2] == params.value) {
                  return "#1CA4B6";
                } else {
                  return "#C5E419";
                }
              },
            },
            label: {
              show: true,
              position: "top",
            },
            data: value,
            zlevel: 11,
          },
          {
            name: "背景",
            type: "bar",
            barWidth: "30%",
            xAxisIndex: 0,
            yAxisIndex: 1,
            barGap: "-100%",
            data: bkData,
            itemStyle: {
              normal: {
                color: "rgba(255,255,255,0)",
                barBorderRadius: [0, 0, 0, 0],
              },
            },
            tooltip: {
              show: false,
            },
            zlevel: 9,
          },
        ],
      };
    },
    getReportData(id) {
      this.$ajax
        .post(
          this.G_capi + this.ports.consultant.student.report.newReportData,
          {
            reportId: id,
          },
          {
            headers: {
              token: window.sessionStorage.getItem("ymtxToken"),
            },
          }
        )
        .then((res) => {
          if (res.data.code == 2000) {
           
            this.mbti = res.data.data.mbti; //人格特性
            this.intelligent = res.data.data.intelligent; //智能水平
            this.hobby = res.data.data.hobby; //兴趣倾向
            this.radarChart = res.data.data.hobby.radarChart;
            this.threeYard = res.data.data.hobby.threeYard;
            this.profession = res.data.data.profession; //职业价值观
            this.Data = res.data.data.profession.data; // 柱状图
            this.mind = res.data.data.mind; //心里适应性
            this.result = res.data.data.mind.result;
            for (var i = 0; i < this.Data.length; i++) {
              this.radarZhuData.push(this.Data[i].name);
              this.radarZhuVal.push(this.Data[i].value);
            }

            for (var i = 0; i < this.radarChart.length; i++) {
              this.bgArr.push({
                name: this.radarChart[i].type + "-" + this.radarChart[i].name,
                value: this.radarChart[i].value,
                max: 20,
                type: this.radarChart[i].type,
              });
            }

            for (var i = 0; i < this.threeYard.length; i++) {
              for (var j = 0; j < this.bgArr.length; j++) {
                if (this.threeYard[i] == this.bgArr[j].type) {
                  this.bgArr[j].color = "#1CA4B6";
                  // this.bgArr[j].fontSize = "20"
                }
              }
            }

            for (var i = 0; i < this.bgNewArr.length; i++) {
              this.bgArr.forEach((item) => {
                if (this.bgNewArr[i] == item.name) {
                  this.bgNewArr2.push(item);
                }
              });
            }
            for (var i = 0; i < this.bgNewArr2.length; i++) {
              this.radarValue.push(this.bgNewArr2[i].value);
            }

            this.$nextTick(() => {
              // this.countPage();
              this.countPage();
              this.drawBagua(this.bgNewArr2);
              this.drawZhu(this.radarZhuVal);
            });
          } else {
          }
        });
    },
  },
};
</script>

<style lang="less">
.growthFileReport {
  width: 100%;
  .pageInnerBox {
    position: relative;
  }
  .tixing {
    position: absolute;
    right: -190px;
    top: 71px;
    color: red;
  }
  #radarChartContainer {
    width: 100%;
    -webkit-tap-highlight-color: transparent;
    user-select: none;
    position: relative;
    height: 400px;
  }
  .page {
    box-sizing: border-box;
    background-color: #fff;
    padding: 80px 50px;
    width: 900px;
    height: 1279.3px;
    margin-bottom: 20px;
    //border: 1px solid #29AAF4;
    position: relative;
  }
  .pageCover {
    background: url("~@img/xueyezixun/consultant/growthFile/bg_cover.png")
      no-repeat center center;
    padding: 440px 0px 200px 100px;
    .titleBox {
      color: #fff;
      height: 180px;
      margin-bottom: 300px;
      h5 {
        font-size: 60px;
        color: #fff;
        line-height: 1.8;
      }
      .line {
        width: 60px;
        border-bottom: 2px solid #ffff;
        margin-bottom: 20px;
      }
      p {
        font-size: 20px;
        line-height: 40px;
      }
    }
    .nameBox {
      p {
        line-height: 50px;
        font-size: 24px;
      }
      .name {
        color: #0a9bf0;
      }
    }
  }
  .pageBackCover {
    padding-top: 560px;
    background: url("~@img/xueyezixun/consultant/growthFile/bg_back_cover.png")
      no-repeat center center;
    .titleBox {
      color: #fff;
      height: 180px;
      margin-bottom: 300px;
      text-align: center;
      h5 {
        font-size: 60px;
        color: #fff;
        line-height: 1.8;
      }
      p {
        font-size: 20px;
        line-height: 40px;
      }
    }
  }
  .big_page_number {
    width: 100%;
    position: absolute;
    text-align: center;
    font-weight: bold;
    bottom: 30px;
    left: 0;
  }
  .bigTitle {
    padding-left: 20px;
    margin-bottom: 30px;
    background-color: #29aaf4;
    font-size: 24px;
    font-weight: bold;
    line-height: 50px;
    color: #fff;
  }
  .middleTitle {
    line-height: 32px;
    font-size: 20px;
    margin-bottom: 30px;
    font-weight: bold;
    span {
      padding-right: 10px;
      position: relative;
      line-height: 32px;
      display: inline-block;
      &:after {
        content: "";
        position: absolute;
        top: 50%;
        right: -15px;
        margin-top: -8px;
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-left: 14px solid #29aaf4;
        border-bottom: 8px solid transparent;
      }
    }
  }
  .smallTitle {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
    span {
      width: 8px;
      height: 8px;
      background-color: #ffae3a;
      border-radius: 2px;
      position: relative;
      margin-right: 10px;
      &:after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        width: 8px;
        height: 8px;
        background-color: #29aaf4;
      }
    }
  }
  .noContent {
    font-size: 22px;
    font-weight: bold;
  }
  .contentPageList {
    height: 1116px;
    .catalog {
      overflow: hidden;
      margin-bottom: 30px;
      p {
        line-height: 42px;
        float: left;
        border-bottom: 2px solid #29aaf4;
        span {
          font-weight: bold;
          font-size: 30px;
          margin-right: 10px;
        }
      }
    }
    .partTitle {
      font-size: 20px;
      color: #29aaf4;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .main {
      padding-bottom: 30px;
      .small_title_box {
        display: flex;
        line-height: 40px;

        .big_title {
          font-size: 20px;
          color: #7cc156;
          font-weight: 600;
        }

        .line {
          flex: 1;
          border-top: 1px dashed #000;
          margin: auto 0;
        }

        .page_number {
          padding-left: 10px;
          font-size: 18px;
        }
      }
    }
  }
  .contentStudentMessage {
    .main {
      padding-bottom: 35px;
      ul {
        display: flex;
        flex-wrap: wrap;
        li {
          line-height: 32px;
          width: 33%;
          padding-left: 20px;
        }
      }
      .hobby {
        margin-top: 30px;
        position: relative;
        font-size: 14px;
        .title {
          line-height: 24px;
          position: absolute;
          left: 15px;
          top: -12px;
          padding: 0 10px;
          border-radius: 3px;
          color: #fff;
        }
        .detail {
          padding: 15px 15px 6px 15px;
          background-color: #f6f6f6;
          min-height: 70px;
          line-height: 25px;
          color: #969696;
        }
      }
    }
  }
  .contentStudentGrade {
    padding-bottom: 40px;
    .gradeBox {
      p {
        background-color: #e5f2f9;
        border-radius: 3px;
        margin-bottom: 10px;
        line-height: 36px;
        padding-left: 10px;
        span {
          margin-right: 30px;
        }
      }
      ul {
        font-size: 15px;
        display: flex;
        flex-wrap: wrap;
        li {
          width: 25%;
          line-height: 32px;
        }
      }
    }
  }
  .contentCompetition {
    padding-bottom: 50px;
    table {
      width: 100%;
      tr {
        line-height: 40px;
        text-align: center;
      }
      thead {
        tr {
          th {
            text-align: center;
            border: 1px solid #29aaf4;
            background-color: #e5f2f9;
            font-weight: bold;
          }
        }
      }
      tbody {
        font-size: 14px;
        tr {
          th {
            background-color: #e5f2f9;
            border: 1px solid #29aaf4;
            color: #29aaf4;
          }
          td {
            background-color: #f3fafb;
            border: 1px solid #29aaf4;
          }
        }
      }
    }
  }
  .contentMyGoal {
    padding: 10px 0 40px;
  }
  .contentRecord {
    min-height: 1160px;
    table {
      font-size: 16px;
      width: 800px;
      margin: 0 auto;

      thead {
        tr {
          line-height: 42px;
          text-align: center;
          th {
            border: 1px solid #29aaf4;
            background-color: #e5f2f9;
            font-weight: bold;
            text-align: center;
          }
        }
      }
      tbody {
        line-height: 40px;
        text-align: center;
        font-size: 14px;
        tr {
          th {
            text-align: center;
            background-color: #e5f2f9;
            border: 1px solid #29aaf4;
            color: #29aaf4;
          }
          td {
            background-color: #f3fafb;
            border: 1px solid #29aaf4;
          }
        }
      }
    }
  }
  .contentTargetSplit {
    padding-bottom: 20px;
    .target {
      padding-top: 10px;
      padding-bottom: 20px;
      .targetTitle {
        padding-left: 10px;
        line-height: 30px;
        //font-weight: bold;
        margin-bottom: 10px;
        background-color: #e5f2f9;
      }
      .targetBox {
        p {
          span {
            margin-right: 30px;
          }
        }
        ul {
          display: flex;
          flex-wrap: wrap;
          font-size: 15px;
          li {
            width: 25%;
            line-height: 32px;
          }
        }
      }
    }
  }
  .contentPlanStudyDevelop {
    overflow: hidden;
    padding-bottom: 10px;
    .hobbit {
      padding: 20px 15px 10px;
      position: relative;
      background-color: #f6f6f6;
      border-radius: 6px;
      font-size: 16px;
      margin-top: 20px;
      p {
        line-height: 25px;
        font-size: 14px;
        margin-bottom: 10px;
        span {
          font-weight: bold;
        }
      }
      .title {
        position: absolute;
        left: 15px;
        top: -12px;
        padding: 0 5px;
        height: 24px;
        line-height: 24px;
        background-color: #29aaf4;
        color: #fff;
        border-radius: 2px;
      }
    }
  }
  .contentPlanStatistics {
    padding-bottom: 30px;
    table,
    th,
    td {
      border: 1px solid #29aaf4;
      color: #5c5c5c;
      font-size: 13px;
      background-color: #f3fafb;
    }
    table {
      font-size: 16px;
      border-collapse: collapse;
      width: 100%;
      text-align: center;
    }
    td,
    th {
      line-height: 44px;
    }
    th {
      background: #e5f2f9;
      font-size: 14px;
      p {
        line-height: 22px;
      }
    }
    .border0 {
      padding: 0;
      height: 100%;
      //vertical-align:text-top;
    }
    .table {
      border-style: hidden;
      border-width: 0;
      height: 100%;
    }
    .table2 {
      td {
        line-height: 22px;
      }
    }
  }
}
</style>